import { Link } from "react-router-dom";
import { Globe, Linkedin } from "lucide-react";
import { services } from "@/data/services";

const Footer = () => {
  return (
    <footer className="gradient-navy text-primary-foreground">
      <div className="container py-16">
        <div className="grid gap-10 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-rcg-sky">
                <span className="font-display text-lg font-bold text-white">R</span>
              </div>
              <span className="font-display text-xl font-bold">RCG</span>
            </div>
            <p className="text-sm text-primary-foreground/80 leading-relaxed">
              Robinson Consulting Group — Service Disabled Veteran-Owned Small Business delivering mission-critical systems engineering and integration across Government.
            </p>
          </div>

          {/* Quick Links */}
          <nav aria-label="Company links">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider mb-4 text-rcg-sky">Company</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/about" className="hover:text-rcg-sky transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-rcg-sky transition-colors">Services</Link></li>
              <li><Link to="/careers" className="hover:text-rcg-sky transition-colors">Careers</Link></li>
              <li><Link to="/blog" className="hover:text-rcg-sky transition-colors">Blog</Link></li>
              <li><a href="https://outlook.office365.com/" target="_blank" rel="noopener noreferrer" className="hover:text-rcg-sky transition-colors">Employee Log-In</a></li>
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Services links">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider mb-4 text-rcg-sky">Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link to={`/services/${service.slug}`} className="hover:text-rcg-sky transition-colors">
                    {service.shortTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider mb-4 text-rcg-sky">Contact</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>Washington, D.C. Metro Area</li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <Link to="/contact" className="inline-block rounded-md bg-rcg-blue px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-rcg-dark">Get in Touch</Link>
              <a href="https://www.linkedin.com/company/robinsoncg" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/80 hover:text-rcg-sky transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-foreground/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/60">
          <div className="flex items-center gap-2">
            <p>© {new Date().getFullYear()} Robinson Consulting Group. All rights reserved.</p>
            <Link to="/admin" className="text-primary-foreground/30 hover:text-primary-foreground/50 transition-colors" aria-label="Admin">
              <Globe size={14} />
            </Link>
          </div>
          <p>Service Disabled Veteran-Owned Small Business (SDVOSB)</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
